import { FC } from 'react';
import { useStyles } from './ResourceFolderIcon.styles';

export interface ResourceFolderCenterIconProps {
  color: string;
  count: number;
}

export const ResourceFolderIcon: FC<ResourceFolderCenterIconProps> = ({ color, count }) => {
  const styles = useStyles({ color });

  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="96.411" height="71.513" viewBox="0 0 96.411 71.513">
        <g data-name="Group 20903">
          <g data-name="Layer 38">
            <path
              data-name="Path 17324"
              d="M75.929 70.6H9.325A8.325 8.325 0 0 1 1 62.278V12.325A8.325 8.325 0 0 1 9.325 4h22.2a2.775 2.775 0 0 1 2.137 1l8.409 10.1h33.858a8.325 8.325 0 0 1 8.325 8.325v38.853a8.325 8.325 0 0 1-8.325 8.322z"
              transform="translate(5 .91)"
              className={styles.backdrop}
              fill={color}
            />
          </g>
          <g data-name="Layer 38">
            <path
              data-name="Path 17324"
              d="M75.929 70.6H9.325A8.325 8.325 0 0 1 1 62.278V12.325A8.325 8.325 0 0 1 9.325 4h22.2a2.775 2.775 0 0 1 2.137 1l8.409 10.1h33.858a8.325 8.325 0 0 1 8.325 8.325v38.853a8.325 8.325 0 0 1-8.325 8.322z"
              transform="translate(-1 .91)"
              fill={color}
            />
          </g>
          <g data-name="Group 20798">
            <g data-name="Group 20463">
              <g data-name="Group 13175">
                <path
                  data-name="Path 11085"
                  d="M11.271.226c-.006-.03-.008-.2-.009-.226a66.606 66.606 0 0 0-5.323 5.542q-1.38 1.673-2.66 3.44l.014-.017Q1.55 11.324 0 13.849c1.25-1.885 4.623-2.323 7.144-3.537C9.742 9.029 11.493 6.975 11.271.226z"
                  transform="scale(-1) rotate(-56 -50.279 77.17)"
                  fill="#4dbea0"
                />
                <path
                  data-name="Path 11086"
                  d="M11.273.3a.581.581 0 0 0-.164-.031C4.941-.919 2.345 2.066 1.422 5.287.432 8.6 1.115 12.151 0 14.119A66.208 66.208 0 0 1 11.273.3z"
                  transform="scale(-1) rotate(-56 -50.533 77.305)"
                  fill="#4dbea0"
                />
                <g data-name="Group 13112">
                  <path
                    data-name="Path 11087"
                    d="m10.977.338-.014-.03.027-.028.128-.132-.16.019a.609.609 0 0 0-.165-.023C7.92-.251 5.6.167 3.908 1.381a7.388 7.388 0 0 0-2.8 4.37A20.383 20.383 0 0 0 .6 10.462a11.3 11.3 0 0 1-.529 3.964c-.056.133-.089.252-.063.271s.11-.068.195-.182C1.055 13.357 2.72 12.7 4.476 12a25.591 25.591 0 0 0 2.657-1.17C9.85 9.332 11.447 7.072 11.019.444a.475.475 0 0 0-.042-.106zM7.086 10.714a25.34 25.34 0 0 1-2.646 1.165 10.628 10.628 0 0 0-4.167 2.359 12.722 12.722 0 0 0 .448-3.779 20.311 20.311 0 0 1 .5-4.68 7.253 7.253 0 0 1 2.744-4.29c1.672-1.2 3.96-1.606 6.8-1.216H10.822a.307.307 0 0 0 .005.032.4.4 0 0 0 .044.095l.029.067c.421 6.548-1.147 8.775-3.814 10.247z"
                    transform="scale(-1) rotate(-56 -50.946 77.47)"
                    fill="#5a3d1c"
                  />
                  <path
                    data-name="Path 11088"
                    d="M0 12.089A75.268 75.268 0 0 1 10.323.2a.119.119 0 0 0 0-.157.111.111 0 0 0-.156-.025 76.413 76.413 0 0 0-9.94 11.7z"
                    transform="scale(-1) rotate(-56 -52.647 76.35)"
                    fill="#5a3d1c"
                  />
                </g>
              </g>
              <g data-name="Group 20401">
                <path
                  data-name="Path 11085"
                  d="M11.212.214C11.2.185 11.193.022 11.191 0a56.473 56.473 0 0 0-5.343 4.934q-1.372 1.5-2.634 3.1l.014-.015A54.555 54.555 0 0 0 0 12.45c1.223-1.711 4.773-1.927 7.379-2.928 2.684-1.062 4.429-2.903 3.833-9.308z"
                  transform="rotate(173.06 47.388 16.182)"
                  fill="#4dbea0"
                />
                <path
                  data-name="Path 11086"
                  d="M11.2.463a.725.725 0 0 0-.175-.039C4.43-1.062 1.839 1.611 1.034 4.608.163 7.685 1.076 11.089 0 12.886A54.7 54.7 0 0 1 11.2.463z"
                  transform="rotate(173.06 47.401 16.4)"
                  fill="#4dbea0"
                />
                <g data-name="Group 13112">
                  <path
                    data-name="Path 11087"
                    d="m10.863.471-.017-.029.027-.025L11 .3l-.169.008a.752.752 0 0 0-.176-.032c-3.063-.543-5.494-.284-7.227.765A5.994 5.994 0 0 0 .7 5.014a16.8 16.8 0 0 0-.288 4.432 9.238 9.238 0 0 1-.349 3.722c-.052.123-.081.233-.052.253s.113-.058.2-.161c.84-1.046 2.568-1.572 4.391-2.128a25.818 25.818 0 0 0 2.752-.952c2.8-1.259 4.369-3.3 3.561-9.607a.478.478 0 0 0-.052-.102zM7.3 10.067a25.568 25.568 0 0 1-2.74.947C2.822 11.543 1.172 12.047.266 13a10.443 10.443 0 0 0 .273-3.551 16.735 16.735 0 0 1 .284-4.4A5.884 5.884 0 0 1 3.5 1.148C5.207.113 7.609-.14 10.642.4H10.7a.281.281 0 0 0 .007.031.4.4 0 0 0 .045.09l.032.063c.801 6.23-.742 8.246-3.484 9.483z"
                    transform="rotate(173.06 47.386 16.59)"
                    fill="#5a3d1c"
                  />
                  <path
                    data-name="Path 11088"
                    d="M0 10.844A62.987 62.987 0 0 1 10.3.2a.1.1 0 0 0-.007-.15.13.13 0 0 0-.166-.032 63.714 63.714 0 0 0-9.9 10.489z"
                    transform="rotate(173.06 46.61 16.97)"
                    fill="#5a3d1c"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <div className={styles.containerNumber}>
        <span className={styles.number}>{count}</span>
      </div>
    </div>
  );
};
